import React from "react";
import { connect } from 'react-redux';
import ReactTable from 'react-table';
import SlidingPanel from 'react-sliding-side-panel';
import Segmented from "rc-segmented";

//import moment from 'moment';
//import 'moment-duration-format';
import { arrayIsNotEmpty, isDefined, sortReactTable } from '../../../../utils';
import { pageLoaded } from '../../../../utils';
import { columnsAccessors } from '../../../../constants';
import UserCreator from '../../../../components/v3/AdminScreenV3/UserCreator';
import UserProfileEditor from '../../../../components/v3/AdminScreenV3/UserProfileEditor';
import ZSearch from '../../../../components/Common/ZSearch';
import UserAvatar from '../../../../icons/v3/UserAvatar';

import LoadingControl from '../../../../components/LoadingControl';
//import GroupsIcon from '@material-ui/icons/Group';
import { ZRole } from '../../../../generated';

import {
    updateProps,
    loadUsersScreen,
    createNewUser,
    terminateUser,
    activateUser,
    updateUser,
} from './UsersScreenActions';

class UsersScreen extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            newUser: undefined,
            showCreateNewUserPopUp: false,
            showUserProfileEditor: false,
            currentAgentIdToEdit: undefined,
            newUserName: undefined,
            searchUserQuery: undefined,
            selectedUserActivationType: 'active',
        };

        this.showCreateNewUserPopUp = this.showCreateNewUserPopUp.bind(this);
        this.closeCreateNewUserPopUp = this.closeCreateNewUserPopUp.bind(this);

        this.showUserProfileEditor = this.showUserProfileEditor.bind(this);
        this.hideUserProfileEditor = this.hideUserProfileEditor.bind(this);

        this.onSearchUser = this.onSearchUser.bind(this);

        this.getUsersResultTable = this.getUsersResultTable.bind(this);
        this.getUserProfileEditor = this.getUserProfileEditor.bind(this);

        this.terminateUser = this.terminateUser.bind(this);
    }

    componentDidMount() {
        pageLoaded('UsersScreen');
        this.props.dispatch(loadUsersScreen());
    }

    setSelectedUserActivationType = (value) => {
        this.setState({ selectedUserActivationType: value });
    }

    terminateUser(userId) {
        this.props.dispatch(terminateUser(userId));
        this.hideUserProfileEditor();
    }

    activateUser = (userId) => {
        this.props.dispatch(activateUser(userId));
        this.hideUserProfileEditor();
    }

    showUserProfileEditor(currentAgentIdToEdit) {
        this.setState({ showUserProfileEditor: true, currentAgentIdToEdit });
    }

    hideUserProfileEditor() {
        this.setState({ showUserProfileEditor: false, currentAgentIdToEdit: undefined });
    }

    showCreateNewUserPopUp() {
        this.setState({ showCreateNewUserPopUp: true });
    }

    closeCreateNewUserPopUp(name, email, roleId, id, teamId) {
        const newUser = {
            Name: name,
            Email: email,
            roleId: roleId,
            externalId: id,
            teamId: teamId
        };
        this.setState({
            showCreateNewUserPopUp: false,
            newUser: newUser,
        });
        if (isDefined(name) && isDefined(email)) {
            this.props.dispatch(createNewUser(newUser));
        }
    }

    onSearchUser({ target }) {
        this.setState({ searchUserQuery: target.value });
    }

    onUpdateUser = (userUpdateInfo) => {
        this.props.dispatch(updateUser(userUpdateInfo));
        this.setState({ showUserProfileEditor: false, currentAgentIdToEdit: undefined });
    }

    getUserProfileEditor(filteredUsersSummary) {
        const
            {
                allTeams,
                domainValues
            } = this.props;

        const userToShow = filteredUsersSummary.find(u => u.id === this.state.currentAgentIdToEdit);

        return (<SlidingPanel
            style={{ backgroundColor: '#FDF9FB' }}
            type={'right'}
            isOpen={this.state.showUserProfileEditor}
            size={30}
            backdropClicked={this.hideUserProfileEditor}>
            <UserProfileEditor
                domainValues={domainValues}
                userToShow={userToShow}
                terminateUser={this.terminateUser}
                activateUser={this.activateUser}
                allTeams={allTeams}
                onUpdateUser={this.onUpdateUser} />
        </SlidingPanel>);
    }

    getUsersResultTable(filteredUsersSummary) {

        let result = {};
        const nameColumn = {
            Header: 'Name',
            accessor: 'nameNode',
        };
        const roleColumn = {
            Header: 'Role',
            accessor: 'role',
        };
        const teamsColumn = {
            Header: 'Team',
            accessor: 'teams'
        };

        const actionColumn = {
            Header: 'Action',
            accessor: columnsAccessors.action
        };

        result.columns = [nameColumn, roleColumn, teamsColumn,  /*,*/];

        if (this.state.selectedUserActivationType === 'all') {
            result.columns.push({
                Header: 'User Status',
                accessor: 'isTerminatedFormatted'
            });
        }

        result.columns.push(actionColumn);

        result.data = arrayIsNotEmpty(filteredUsersSummary) ? filteredUsersSummary : [];

        //filter by teamName
        if (isDefined(this.state.searchUserQuery) && this.state.searchUserQuery !== '') {
            result.data = result.data.filter(a => a.name.toLowerCase().includes(this.state.searchUserQuery.toLowerCase()));
        }

        //form table body by adding icons and styling
        if (result.data && Array.isArray(result.data)) {
            result.data.forEach(row => {
                if (isDefined(row.name)) {
                    row.nameNode = (<div className="flex-container-start" style={{ marginLeft: "10px" }}>
                        <div style={{ width: '48px', height: '48px' }}>
                            <UserAvatar />
                        </div>
                        <div style={{ margin: "0 0 10px 10px" }}>{row.name}</div>
                    </div>)
                }

                if (isDefined(row.teamNames)) {
                    row.teamsToShow = row.teamNames.join(", ")
                }

                if (isDefined(row.isEnabled)) {
                    var statusName = row.isEnabled ? 'Active' : 'Terminated'

                    const avatarStyle = row.isEnabled ? "active-user" : "terminated-user";
                    row.status = (<div className={avatarStyle}>
                        {statusName}
                    </div>);

                }

                if (this.state.selectedUserActivationType === 'all') {
                    var statusName = row.isTerminated ? 'Terminated' : 'Active';

                    const avatarStyle = row.isTerminated ? "terminated-user" : "active-user";
                    row.isTerminatedFormatted = (<div className={avatarStyle}>
                        {statusName}
                    </div>);
                }

                row.action = <div className="active-user" onClick={() => this.showUserProfileEditor(row.id)} > View/Edit Profile</div >
            })
        }

        const loading = !filteredUsersSummary;
        const usersResultTable = (<ReactTable
            data={result.data}
            columns={result.columns}
            defaultPageSize={10}
            loading={loading}
            className='admin-page-users-table -striped -highlight'
            getTrProps={(state, rowInfo) => {
                if (rowInfo && rowInfo.row && rowInfo.original) {
                    return {
                        onClick: () => {
                            //onClick(rowInfo.original.id)
                        }
                    };
                } else {
                    return {};
                }
            }}
            defaultSortMethod={sortReactTable}
        />);

        return usersResultTable;
    }

    render() {
        const
            {
                currentUser,
                teamsHierarchy,
                usersSummary,
                allTeams
            } = this.props;
        if (!currentUser || !arrayIsNotEmpty(teamsHierarchy) || !arrayIsNotEmpty(usersSummary) || !arrayIsNotEmpty(allTeams)) {
            return <LoadingControl />;
        }
        if (currentUser.RoleId !== ZRole.Manager &&
            currentUser.RoleId !== ZRole.Admin &&
            currentUser.RoleId !== ZRole.SuperAdmin) {
            return <LoadingControl />;
        }

        const filteredUsersSummary = this.state.selectedUserActivationType === 'active'
            ? usersSummary.filter(a => a.isTerminated === false) : usersSummary;
        const userProfileEditor = isDefined(this.state.currentAgentIdToEdit) ? this.getUserProfileEditor(filteredUsersSummary) : undefined;
        const userSearch = (<ZSearch placeHolder="Search user name" searchValue={this.state.searchUserQuery} onChange={this.onSearchUser} />);
        const userCount = filteredUsersSummary
            ? (<p className="H2-white" style={{ marginLeft: '10px' }}>({filteredUsersSummary.length} users)</p>)
            : undefined;

        var usersResultTable = this.getUsersResultTable(filteredUsersSummary);
        const createNewUserButton = (
            <div className="v3-button agent-view-interactions" onClick={this.showCreateNewUserPopUp}>
                New User
            </div>);

        return (
            <div className="main-page-width">
                <div className="teams-table-for-manager filters-wrapper" style={{ marginTop: '28px' }}>
                    <div className="teams-table-for-manager filter-area-title-wrapper">
                        <label className="teams-table-for-manager all-teams-title">All Users {userCount}</label>
                        {createNewUserButton}
                    </div>
                    <div style={{ margin: '3px 20px' }}>
                        <Segmented
                            defaultValue={this.state.selectedUserActivationType}
                            onChange={this.setSelectedUserActivationType}
                            options={[
                                { label: "Show Active", value: 'active' },
                                { label: "Show All", value: 'all' },
                            ]}
                        />
                    </div>
                    <div className="teams-table-for-manager teams-filter-names-wrapper">
                        {userSearch}
                    </div>
                </div>
                <div style={{ position: 'relative', zIndex: 0 }}>
                    {usersResultTable}
                </div>
                {userProfileEditor}
                {this.state.showCreateNewUserPopUp &&
                    (<UserCreator
                        allTeams={allTeams}
                        selectSurveyFormType={this.selectSurveyFormType}
                        onClose={this.closeCreateNewUserPopUp} />)}
            </div>);
    }
}

const select = state => ({ ...state.UsersScreen, ...state.session });

export default connect(select)(UsersScreen);